<template>
  <EgovTimeModal
    v-model="internalValue"
    :secondsRemaining="secondsRemaining"
    defaultWidth="360px"
    fixedWidth
    title="Session Timeout"
    description="For your security, you will be logged out after a certain amount of inactivity."
    timerHeading="Time Remaining:"
    primaryButtonLabel="Continue Session"
    secondaryButtonLabel="Log Out Now"
    @left-cta="emit('logout')"
    @timeout="emit('logout')"
    @right-cta="emit('continue')"
    @close="emit('continue')"
  />
</template>

<script setup>
import { ref, watch } from 'vue'
import EgovTimeModal from './EgovTimeModal.vue'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  secondsRemaining: { type: Number, default: 300 },
})

const emit = defineEmits(['update:modelValue', 'logout', 'continue'])

const internalValue = ref(props.modelValue)
watch(
  () => props.modelValue,
  (v) => (internalValue.value = v),
)
watch(internalValue, (v) => emit('update:modelValue', v))
</script>
